<template>
<Nav />
<div class="content">
  <h1>Wilder Sensing Portal</h1>
  <p>Welcome to the Wilder Sensing Portal</p>
  <p>To view your dashboard, please navigate <router-link to="dashboard">here</router-link></p>
</div>
<Footer />
</template>

<script>
import Nav from '@/components/Nav.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'AboutView',
    components: {Nav, Footer, },
}
</script>
